export const lang = {
    logout: {
        atten: "注销账户后<br>您的登录账号将被重置<br>专注时长、种子、已购道具等都会被清零",
        keyWords: "我要注销",
        placeholder: '继续操作输入“我要注销”',
        confirm: "确定注销",
        keyWordsAtten: "请输入正确的关键词",
        logoutSuccess: "注销成功"
    },
    feedback: {
        cateTitle: "选择分类",
        contentTitle: "反馈内容",
        placeholder1: "请输入意见或建议（500字以内）",
        contactTitle: "联系方式（选填）",
        placeholder2: "微信/邮箱/手机号",
        atten1: "最多只能上传3张图片",
        atten2: "图片大小不能超过5M",
        atten3: "请输入或上传反馈内容",
        submitSuccess: "提交成功",
        submitBtn: "提交"
    },
    title: {
        focus: "专注",
        feedback: "意见反馈",
        logout: "注销",
        privacy: "隐私政策",
        user: "用户协议",
        membercentre: "会员中心",
        member: "会员服务协议",
        recharge: "充值",
        record: "种子记录"
    },
    vip: {
        currency: '¥',
        title: '专注VIP套餐',
        unitA: '个月',
        unitI1: '连续包',
        unitI2: '',
        unitI2: '',
        unitI3: '',
        unitI4: '',
        unitI5: '月',
        unitI6: '月',
        unitI7: '季',
        unitI8: '年',
        buyBtn1: '立即订阅',
        buyBtn2: '已订阅',
        buyBtn3: '立即购买',
        tip: '订阅后会从您的iTunes账户中扣除相关费用。如需关闭订阅，请在当前订阅周期结束前至少24小时内通过手机设置的App Store订阅管理中自动续费功能，',
        memberBtn: '会员服务协议',
        discountTxt: '首月特惠',
        expired: '到期',
        expired1: '',
        bg1: 'bg_ch1.png',
        bg2: 'bg_ch2.png',
        bg3: 'bg_ch3.png',
        seeds: '颗',
        myseed: '我的种子',
        successTip: '购买种子成功',
        present: '赠送',
        present1: '颗',
        userAgreement: '会员服务协议',
        privacy: [
            {
                title: "1.服务条款的接受与修改",
                content: [
                    "1.1 本协议是用于用户成为专注ing VIP会员且使用专注ing提供的VIP会员服务所订立的协议。本协议描述专注ing与VIP会员之间关于软件许可以及服务使用及相关方面的权利义务。“VIP会员”或“您”是指享受专注ing提供的VIP会员服务的个人或单一实体。本服务协议构成您（无论个人或者单位）使用专注ing所提供的VIP会员服务之先决条件，除非您接受本协议条款，否则您无权使用本协议的相关服务。您的使用行为将视为同意接受本协议各项条款的约束。",
                    "1.2专注ing有权随时对服务条款进行修改，一旦服务条款发生变更和修改，专注ing将在相关页面上提示修改的内容；如果VIP会员不同意本协议的修改，可以取消已经获取的服务并停止使用；如果VIP会员继续使用专注ing提供的服务，则视为VIP会员已经接受本协议的全部修改。",
                    "1.3 请您审阅并接受或不接受本协议，未成年人应在法定监护人陪同下审阅和履行，未成年人行使和履行本协议项下的权利和义务视为已获得了法定监护人的认可，您在享受专注ing VIP会员服务时必须完全、严格遵守本服务协议条款。"
                ]
            },
            {
                title: "成为VIP会员的程序",
                content: [
                    "2.1 在成为专注ing VIP会员之前，您必须先根据真实、准确信息注册成为专注ing用户。用户所填写的内容与个人资料必须真实有效，否则专注ing有权拒绝其申请或撤销其VIP会员资格，并不予任何赔偿或退还VIP会员服务费。VIP会员的个人资料发生变化，应及时修改注册的个人资料，否则由此造成的VIP会员权利不能全面有效行使的责任由VIP会员自己承担，专注ing有权因此取消其VIP会员资格，并不予退还VIP会员费或其他任何形式的任何赔偿。",
                    "2.2 用户可通过各种已有和未来新增的渠道成为专注ing VIP会员，包括但不限于：通过手机支付或第三方支付等方式成为VIP会员。在用户使用具体某种方式成为VIP会员时，须阅读并确认接受相关的服务条款和使用方法。专注ing在此声明：专注ing从未授权任何第三方单位或个人销售、转让专注ing VIP会员资格，任何未经授权销售专注ing VIP会员的属于非法销售，专注ing有权追究其法律责任。",
                    "2.3 成为VIP会员后，VIP会员有权利不接受专注ing的服务，可申请取消VIP会员服务，但不获得VIP会员服务费的退还。",
                    "2.4专注ing VIP会员账号所有权归专注ing所有，VIP会员拥有专注ing账号的有限使用权。",
                    "2.5专注ing仅提供相关的网络服务，除此之外与相关网络服务有关的设备（如个人电脑、手机、及其他与接入互联网或移动网有关的装置）及所需的费用（如为接入互联网而支付的电话费及上网费、为使用移动网而支付的手机费）均应由VIP会员自行负担。",
                ]
            },
            {
                title: "VIP会员的权利及限制",
                content: [
                    "3.1 在VIP会员有效期内，VIP会员可优先参加由专注ing组织的活动并享有由专注ing提供的各项优惠及增值服务。",
                    "3.2 VIP会员服务仅限于申请账号自行使用；VIP会员服务期内不能在专注ing帐号之间转移，禁止赠与、借用、作用、转让或售卖。否则专注ing有权在未经通知的情况下取消转让账户、受让账户的VIP会员服务资格，由此带来的损失由VIP会员自行承担。",
                    "3.3 若VIP会员的行为持续违反本协议或违反国家相关法律法规，或专注ing认为VIP会员行为有损专注ing或他人的声誉及利益，专注ing公司有权取消该VIP会员的VIP会员资格而无须给与任何补偿。",
                    "3.4 VIP会员不得以盗窃、利用系统漏洞等非法途径以及在未获专注ing授权的非法销售专注ing VIP会员的网站上获取或购买VIP会员服务，否则专注ing有权取消VIP会员的服务资格。有此引发的问题由VIP会员自行承担，专注ing不负任何责任。",
                    "3.5 任何VIP会员不得使用带有非法、淫秽、污辱或人身攻击的含义污辱或人身攻击的呢称和签名档，一经发现，专注ing有权取消其VIP会员资格而无需给与任何补偿和退费。",
                    "3.6 被取消VIP会员资格的VIP会员，不能再参加由专注ing组织的活动并不可再享有由专注ing提供的各项优惠及增值服务，即不再享有VIP会员权利。"
                ]
            },
            {
                title: "VIP会员服务和账号查询",
                content: [
                    "4.1 一旦您成为专注ing VIP会员，即视为您认可该项服务标明之价格；成为专注ing VIP会员后，该项服务即时生效。",
                    "4.2 VIP会员的增值服务资费标准以专注ing网站上标注的详细资费标价为准，专注ing有权基于自身业务发展需要变更上述资费标准，但专注ing会根据实际运营情况对不同阶段已经激活且持续有效的VIP会员给予续费、升级方面的不同资费优惠，具体优惠政策以专注ing在相关服务页面公告的内容为准。",
                    "4.3 您可以通过登录专注ing VIP会员中心免费查询您的账号信息详情，包括已开通的服务内容、服务期限等。"
                ]
            },
            {
                title: "VIP会员权限及服务期限",
                content: [
                      "5.1 您在购买专注ing VIP会员后可享受的全部权益以专注ing App公布的会员权益为准，专注ing有权基于专注ing自身业务发展需要变更全部或部分会员权益。就前述权益调整专注ing将在相应服务页面进行通知或公告，您也可通过专注ing App查询最新的会员权益内容。"
               ]
            },
            {
                title: "服务说明",
                content: [
                    "6.1专注ing VIP会员服务涉及的专注ing产品所有权以及相关软件知识产权归专注ing所有。专注ing所提供的服务将按照其服务条款和操作规则严格执行。VIP会员在享受专注ing任何单项服务时，应当受本协议以及《专注ing网络服务使用协议》的约束。",
                    "6.2专注ing享有对VIP会员网上一切活动的监督、提示、检查的权利，如VIP会员的行为违反有关法律法规或违反本协议条款的约定，专注ing享有要求其纠正及追究其责任等权利。",
                    "6.3专注ing向VIP会员提供的全部服务，均仅限于VIP会员在专注ing平台使用，任何以恶意破解等非法手段将专注ing提供的服务内容与专注ing平台分离的行为，均不属于本协议中约定的专注ing提供的服务。由此引起的一切法律后果由行为人负责，专注ing将依法追究行为人的法律责任。",
                    "6.4 当VIP会员使用专注ing各单项服务时，VIP会员的使用行为视为其对各单项服务的服务条款以及专注ing在该单项服务中发出各类公告的同意。",
                    "6.5 您明确了解并同意，专注ing VIP会员的付费方式为代收费运营商托收的付款方式，您通过此种付费方式付费可能存在一定的商业风险，包括但不限于不法分子利用您账户或银行卡等有价卡等进行违法活动，该等风险均会给您造成相应的经济损失。您应自行承担向侵权方追究侵权责任和追究责任不能的后果。",
                    "6.6 您应自行负责妥善且正确地保管、使用、维护您在专注ing申请取得的账户、账户信息及账户密码。您应对您账户信息和账户密码采取必要和有效的保密措施。非专注ing原因致使您账户密码泄漏以及因您保管、使用、维护不当造成损失的，专注ing无须承担与此有关的任何责任。",
                    "6.7专注ing不对您因第三方的行为或不作为造成的损失承担任何责任，包括但不限于支付服务和网络接入服务、任意第三方的侵权行为。"
                ]
            },
            {
                title: "协议的变更",
                content: [
                    "7.1专注ing依据本协议的约定变更服务内容、服务方式以及本用户协议内容的，如果VIP会员不同意专注ing的变更，有权选择取消并停止使用已经获取的对应的全部或部分服务；如果VIP会员继续使用专注ing提供的上述服务，则视为VIP会员已经接受专注ing的上述调整。",
                    "7.2专注ing对VIP会员协议一旦进行修改，将在页面上公示修改的内容。一经公布即视为通知VIP会员。",
                    "7.3 VIP会员服务提供的视频使用期限中包含专注ing解决故障、服务器维修、调整、升级等所需用的合理时间，对上述情况所需用的时间专注ing不予补偿并保留解释权。",
                    "7.4 VIP会员在使用专注ing所提供的服务时，如遭受任何人身或财务的损失、损害或伤害，不论原因如何，专注ing均不负责任。由于VIP会员将个人密码告知他人或与他人共享注册帐户，由此导致的任何个人资料泄露，专注ing不负任何责任。",
                    "7.5 VIP会员如果不同意条款的修改，可主动向专注ing提出终止VIP会员服务，但专注ing不退还自开通VIP会员服务至提出终止VIP会员服务所在月的已享受VIP会员服务的部分费用；如果VIP会员继续享用VIP会员服务，则视为VIP会员已经接受条款的修改。"
                ]
            },
            {
                title: "服务的中断和终止",
                content: [
                    "8.1 因发生专注ing不可抗拒的事由，如政府行为、不可抗力，导致VIP会员服务无法继续，专注ing会以最快的速度通知VIP会员，但不承担由此对VIP会员造成的任何损失并不退还VIP会员服务费。",
                    "8.2 如VIP会员违反或被视为违反本服务条款中的内容，专注ing有权在不通知VIP会员的情况下立即终止您已购买的所有服务，以及取消您的专注ing VIP会员账户和使用权限，但不退还任何已缴纳的VIP会员服务费用。",
                    "8.3专注ing未行使或延迟行使其在本协议项下的权利并不构成对这些权利的放弃，而单一或部分行使其在本协议项下的任何权利并不排斥其任何其它权利的行使。专注ing随时有权要求您继续履行义务并承担相应的违约责任。"
                ]
            },
            {
                title: "法律的适用和管辖",
                content: [
                    "9.1 本服务条款的生效、履行、解释及争议的解决均适用中华人民共和国法律，本服务条款因与中华人民共和国现行法律相抵触而导致部分无效，不影响其他部分的效力。",
                    "9.2 如就本协议内容或其执行发生任何争议，应尽量友好协商解决；协商不成时，则争议各方一致同意将发生的争议提交协商不成时，任何一方均可向北京市海淀区人民法院提起诉讼。"
                ]
            },
        ]
    }
}